module.exports = __webpack_public_path__ + "img/20.f46f6951.png";